import throttle from 'lodash/throttle';

import ApplyFilters from '../ApplyFilters.js';

export default {
  mixins: [ApplyFilters],
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      mobileOpen: false,
      desktopOpen: false,
      debouncedFunction: null,
      isFakeLoading: false,
      previousScrollPosition: window.scrollY,
      closeOnScrollThrottled: throttle(this.handleScroll, 500),
    };
  },
  computed: {
    submitLabel() {
      return `Show ${this.$store.state.totalRooms} ${this.$store.state.totalRooms === 1 ? 'result' : 'results'}`;
    },
    isLoading() {
      return this.$store.state.loading;
    },
    buttonClasses() {
      return {
        option__button: true,
        'option__button--selected': this.isSelected,
        'option__button--active': this.mobileOpen || this.desktopOpen,
      };
    },
  },
  methods: {
    toggleOpen() {
      if (this.isMobile) {
        this.mobileOpen = !this.mobileOpen;
      } else {
        this.desktopOpen = !this.desktopOpen;
      }
    },
    submit() {
      this.desktopOpen = false;
      this.mobileOpen = false;

      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    handleScroll() {
      const scrolledDistance = Math.abs(window.scrollY - this.previousScrollPosition);

      if (this.desktopOpen && scrolledDistance > 50) {
        this.desktopOpen = false;
      }

      this.previousScrollPosition = window.scrollY;
    },
  },
};
